// ** React Import
import { useEffect, useRef } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useSettings } from "@core/hooks/useSettings";

// ** Layout Components
import SideNavBarLayout from "./SideNavBarLayout";

const Layout = (props) => {
  const hidden = useMediaQuery((theme) => theme.breakpoints.down("md"));
  // ** Props
  const { children } = props;
  const { settings, saveSettings } = useSettings();

  // ** Ref
  const isCollapsed = useRef(settings.navCollapsed);
  useEffect(() => {
    if (hidden) {
      if (settings.navCollapsed) {
        saveSettings({ ...settings, navCollapsed: false, layout: "vertical" });
        isCollapsed.current = true;
      } else {
        saveSettings({ ...settings, layout: "vertical" });
      }
    } else {
      if (isCollapsed.current) {
        saveSettings({
          ...settings,
          navCollapsed: true,
          layout: settings.lastLayout,
        });
        isCollapsed.current = false;
      } else {
        saveSettings({ ...settings, layout: settings.lastLayout });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hidden]);

  return <SideNavBarLayout hidden={hidden}>{children}</SideNavBarLayout>;
};

export default Layout;
